import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect } from "react";
import { useNavigate, useParams } from "react-router";
import { getRootStore } from "@/stores/RootStore";
import { observer } from "mobx-react-lite";
import { canEditDictionaries } from "@/utils/permissions";
import { canDeleteFromDictionaries } from "@/utils/permissions";
import { message, Modal, Skeleton, Card, Button, Flex } from "antd";
import styles from "@/styles/ServiceVehiclePage.module.less";
import { ArrowLeftOutlined, DeleteOutlined } from "@ant-design/icons";
import ServiceVehicleForm from "@/components/ServiceVehicleForm";
export const ServiceVehiclePage = observer(() => {
    const navigate = useNavigate();
    const { vehicleId } = useParams();
    const { singleServiceVehicleStore: store, authStore: { userRole }, } = getRootStore();
    const { vehicle, loading } = store;
    const canEdit = canEditDictionaries(userRole);
    const canDelete = canDeleteFromDictionaries(userRole);
    useEffect(() => {
        store.init(vehicleId);
        return () => {
            store.clearVehicleData();
        };
    }, [vehicleId]);
    const handleBack = () => {
        navigate("/service-vehicles");
    };
    const handleSave = async (values) => {
        const isNewVehicle = !vehicle;
        store.saveVehicle(values).then((savedVehicle) => {
            if (savedVehicle) {
                if (isNewVehicle) {
                    message.success("Сервисный автомобиль успешно создан");
                    navigate(`/service-vehicles/${savedVehicle.id}`);
                }
                else {
                    message.success("Сервисный автомобиль успешно обновлен");
                }
            }
        });
    };
    const handleDeleteVehicle = () => {
        if (!vehicle)
            return;
        Modal.confirm({
            title: "Удаление сервисного автомобиля",
            content: "Вы уверены, что хотите удалить этот автомобиль?",
            okText: "Удалить",
            okType: "danger",
            cancelText: "Отмена",
            onOk: async () => {
                await store.deleteVehicle(vehicle.id);
                message.success("Сервисный автомобиль успешно удален");
                handleBack();
            },
        });
    };
    if (loading) {
        return (_jsx("div", { className: styles.container, children: _jsx(Card, { children: _jsx(Skeleton, { active: true, paragraph: { rows: 8 } }) }) }));
    }
    return (_jsxs(Flex, { vertical: true, gap: "large", className: styles.container, children: [_jsx("div", { className: styles.backButtonContainer, children: _jsx(Button, { icon: _jsx(ArrowLeftOutlined, {}), onClick: handleBack, type: "text", className: styles.backButton, children: "\u041D\u0430\u0437\u0430\u0434 \u043A \u0441\u043F\u0438\u0441\u043A\u0443" }) }), _jsx(ServiceVehicleForm, { vehicle: vehicle, loading: loading, onSubmit: handleSave, onCancel: handleBack, disabled: !canEdit, extraButtons: canDelete &&
                    vehicle && (_jsx(Button, { danger: true, icon: _jsx(DeleteOutlined, {}), onClick: handleDeleteVehicle, children: "\u0423\u0434\u0430\u043B\u0438\u0442\u044C \u0430\u0432\u0442\u043E\u043C\u043E\u0431\u0438\u043B\u044C" })) })] }));
});
export default ServiceVehiclePage;
